import React from "react";
import DocumentTitle from "react-document-title";

import PageHero from "../components/PageHero";
import PageHeroContentSection from "../components/PageHeroContentSection";
import PhotoPreview from "../components/PhotoPreview";
import Lightbox from "../components/Lightbox";
import ArrowSvg from "../components/ArrowSvg";
import AnimatedScrollLink from "../components/AnimatedScrollLink";
//import H5Embed from '../components/H5Embed'
import { getPageTitle } from "../utility/utility";

import preview1 from "../images/building/preview/photo_1_new.jpg";
import preview2 from "../images/building/preview/photo-2.png";
import preview3 from "../images/building/preview/photo-3.jpg";
import preview4 from "../images/building/preview/photo-4.jpg";
import preview5 from "../images/building/preview/photo-5-2.jpeg";
import preview6 from "../images/building/preview/building.png";
import preview7 from "../images/building/preview/photo-7.jpg";
import preview8 from "../images/building/preview/photo-8.jpg";

import full1 from "../images/building/full/photo_1_new.jpg";
import full2 from "../images/building/full/photo-2.jpg";
import full3 from "../images/building/full/photo-3.jpg";
import full4 from "../images/building/full/photo-4.jpg";
import full5 from "../images/building/full/photo-5-2.jpeg";
import full6 from "../images/building/full/building.png";
import full7 from "../images/building/full/photo-7.jpg";
import full8 from "../images/building/full/photo-8.jpg";

import "./Building.scss";

const PHOTOS = [
  {
    preview: preview1,
    full: full1,
    caption: "",
  },
  {
    preview: preview2,
    full: full2,
    caption: "",
  },
  {
    preview: preview3,
    full: full3,
    caption:
      "4 BAM Cinema theaters and a branch of the Brooklyn Public Library within the building.",
  },
  {
    preview: preview4,
    full: full4,
    caption: "29th-floor fitness center with panoramic views.",
  },
  {
    preview: preview5,
    full: full5,
    caption: "",
  },
  {
    preview: preview6,
    full: full6,
    caption: "Unlike anything, in Brooklyn.",
  },
  {
    preview: preview7,
    full: full7,
    caption: "Roof terrace designed by James Corner Field Ops.",
  },
  {
    preview: preview8,
    full: full8,
    caption:
      "BAM:  Brooklyn Academy of Music, has been the home for adventurous artists, audiences and ideas for over 150 years.",
  },
];

export default class BuildingPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      initialLightboxSlide: -1,
    };

    this.jumpToTargetNode = null;
  }

  static pageTitle(listings, routeParams) {
    // eslint-disable-line no-unused-vars
    return "Fort Greene Landmark Apartment Building | 300 Ashland Pl";
  }

  renderPhotoPreview(index) {
    return (
      <PhotoPreview
        photo={PHOTOS[index]}
        className={`photo-preview-${index + 1} collage__item`}
        onClick={() => this.setState({ initialLightboxSlide: index })}
        onKeyPress={() => this.setState({ initialLightboxSlide: index })}
      />
    );
  }

  render() {
    return (
      <DocumentTitle title={getPageTitle(this.constructor, this.props)}>
        <div className="content" id="main" role="main">
          <PageHero heading="The Building">
            <PageHeroContentSection>
              <h2>
                Designed to connect modern residences with the Fort Greene
                community, 300 Ashland is centrally located at a unique
                triangular intersection in the heart of the Brooklyn Cultural
                District.
              </h2>
              <p>
                From the public plaza and the cultural programming at the base
                level, all the way up to the vast green rooftop terrace curated
                by the same designers of The High Line, 300 Ashland offers an
                entirely unconventional yet completely familiar destination for
                modern living in Brooklyn. The luxurious apartments include
                panoramic views and high-end finishes. Residents enjoy a
                full-floor amenity suite featuring a resident lounge, 24-hour
                fitness center and a roof terrace with a sundeck and outdoor
                seating. The building designed by Enrique Norten will also be
                home to 4 BAM Cinema theaters and a branch of the Brooklyn
                Public Library. All just steps away from 11 different subway
                lines, this building is truly{" "}
                <em>unlike anything in Brooklyn.</em>
              </p>
              <AnimatedScrollLink getDomNode={() => this.jumpToTargetNode}>
                Explore 300 Ashland{" "}
                <ArrowSvg className="icon-arrow-sm-svg-down" />
              </AnimatedScrollLink>
            </PageHeroContentSection>
          </PageHero>

          {/*<div id="buildingTour">
            <h2>Take a 3D Tour</h2>
            <div>
              <H5Embed url="https://one.h5property.com/buildings/BAM" />
            </div>
          </div>*/}

          <div
            className="collage"
            ref={(it) => {
              this.jumpToTargetNode = it;
            }}
          >
            <div className="section">
              <div className="column">
                <div>
                  {this.renderPhotoPreview(0)}
                  {this.renderPhotoPreview(1)}
                </div>
                <div className="feature amenities">
                  <div>
                    <h6>Amenities</h6>
                    <p>
                      300 Ashland offers a full suite of services, including a
                      29th floor club house level entirely dedicated to resident
                      amenities.
                    </p>
                    <ul>
                      <li>29th floor fitness center</li>
                      <li>Roof terrace with sun-deck</li>
                      <li>Resident lounge</li>
                      <li>Resident valet and package services</li>
                      <li>24-hour concierge</li>
                      <li>Parking garage</li>
                      <li>Pets allowed</li>
                      <li>Keyless electronic apartment&nbsp;entry</li>
                      <li>Bike Room</li>
                      <li>Apple Store</li>
                      <li>365 by Whole Foods</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="column">
                <div className="row">
                  {this.renderPhotoPreview(2)}
                  <div className="feature facts">
                    <h6>Building Facts</h6>
                    <ul>
                      <li>35 stories</li>
                      <li>379 units</li>
                      <li>
                        Studios,
                        <br />
                        1-bedroom and
                        <br />
                        2-bedrooms
                      </li>
                      <li>
                        Architect: Enrique Norten (TEN Arquitectos) and Ismael
                        Levya Architects
                      </li>
                    </ul>
                  </div>
                </div>
                {this.renderPhotoPreview(3)}
                {this.renderPhotoPreview(4)}
                {this.renderPhotoPreview(5)}
              </div>
            </div>
            <div className="section">
              <div>
                {this.renderPhotoPreview(6)}
                <div className="column">
                  {this.renderPhotoPreview(7)}
                  <div className="feature partnerships">
                    <h6>Cultural Programming</h6>
                    <p>
                      The building features cultural programming and space from
                      iconic Brooklyn institutions.
                    </p>
                    <ul>
                      <li>BAM Cinemas</li>
                      <li>651 ARTS Dance Studio</li>
                      <li>MoCADA</li>
                      <li>Brooklyn Public Library</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Lightbox
            slides={PHOTOS.map((it) => ({
              img: { src: it.full, caption: it.caption },
            }))}
            startSlide={this.state.initialLightboxSlide}
            onClose={() => this.setState({ initialLightboxSlide: -1 })}
          />
        </div>
      </DocumentTitle>
    );
  }
}



// WEBPACK FOOTER //
// ./client/pages/Building.js